import request from '../../../shared/request'

export function getJobDrawings(job_id) {
  return request(`/job/drawings/${job_id}/`)
}

export function createJobDrawing(payload) {
  return request(`/job/drawings/${payload.job_drawing_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobDrawing(payload) {
  return request(`/job/drawings/${payload.job_drawing_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobDrawing(payload) {
  return request(`/job/drawings/${payload.job_drawing_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function uploadDrawingAttachments(payload) {
  return request(`/job/drawings/${payload.drawingId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getDrawingAttachments(drawingId) {
  return request(`/job/drawings/${drawingId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/drawings/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteDrawingAttachment(payload) {
  return request(`/job/drawings/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/drawings.js